import { API_BASE_URL } from "./Constant";
import { dataDisplayRequest } from "./auth_service/AuthServiceHelper";
import axios from "axios";

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );

/* Service layer class for all API related calls */
export default class AxiosService {
  // constructor() { }

  getSearchFunder({ expandId, isExpand }) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/chorusFunders/funder-hierarchy`,
      params: cleanParams({
        funderId: expandId,
        expandId: expandId,
        expandIds: [],
        isExpand: isExpand,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
}
